import { Message, Loading } from 'element-ui'
import i18n from '@/lang'
import { Dispatch } from 'vuex'
import { ElMessageOptions } from 'element-ui/types/message'

// eslint-disable-next-line space-before-function-paren
export default async function ({ dispatch }: { dispatch: Dispatch }) {
  const loading = Loading.service({
    lock: true,
    text: String(i18n.t('playTurbo.custom.savingWarning')),
    spinner: 'el-icon-loading',
    background: 'rgba(0, 0, 0, 0.7)',
  })

  try {
    await dispatch('saveTemplate')
    loading.close()
    Message({
      type: 'success',
      duration: 3000,
      message: i18n.t('playTurbo.custom.saveSuccess'),
    } as ElMessageOptions)
  } catch (e) {
    console.error(e)
    loading.close()
    Message.error(e.message || i18n.t('playTurbo.common.save.fail'))
    throw new Error(e.message || i18n.t('playTurbo.common.save.fail'))
  }
}
